<h2 mat-dialog-title>Change Password</h2>
<mat-dialog-content class="change-password">
  <h4 *ngIf="dialogData?.message">{{ dialogData?.message }}</h4>
  <div class="row my-4 align-items-center">
    <div class="col-md-6 position-relative change-password-background">
      <!-- <img
        class="position-absolute top-0 left-0 w-100 h-100"
        src="./assets/icons/Change Password.svg"
        alt="Change Password"
      /> -->
      <form
        [formGroup]="changePasswordFormGroup"
        class="d-flex flex-column align-items-center w-100"
      >
        <mat-form-field>
          <mat-label class="required-field">Current Password</mat-label>
          <input sanitized
            matInput
            blockCopyCutPaste
            [type]="isCurrentPasswordVisible ? 'text' : 'password'"
            [formControl]="currentPasswordFormControl"
            [maxlength]="passwordLength"
            autofocus
          />
          <mat-icon
            role="button"
            tabindex="0"
            [attr.aria-label]="
              isCurrentPasswordVisible ? 'show password' : 'hide password'
            "
            class="cursor-pointer"
            matSuffix
            (mousedown)="isCurrentPasswordVisible = !isCurrentPasswordVisible"
          >
            {{ isCurrentPasswordVisible ? "visibility" : "visibility_off" }}
          </mat-icon>
          <mat-error> Please enter Current Password. </mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label class="required-field">New Password</mat-label>
          <input sanitized
            matInput
            blockCopyCutPaste
            #newPasswordRef
            [type]="isNewPasswordVisible ? 'text' : 'password'"
            id="new_Password"
            [formControl]="newPasswordFormControl"
            [maxlength]="passwordLength"
          />

          <mat-icon
            role="button"
            tabindex="0"
            [attr.aria-label]="
              isNewPasswordVisible ? 'show password' : 'hide password'
            "
            class="cursor-pointer"
            matSuffix
            (mousedown)="toggleIsNewPassword()"
          >
            {{ isNewPasswordVisible ? "visibility" : "visibility_off" }}
          </mat-icon>

          <mat-error>{{ errorMessageForNewPassword }}</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label class="required-field">Confirm Password</mat-label>
          <input sanitized
            matInput
            blockCopyCutPaste
            [type]="isConfirmPasswordVisible ? 'text' : 'password'"
            [formControl]="confirmPasswordFormControl"
            [maxlength]="passwordLength"
          />
          <mat-icon
            role="button"
            tabindex="0"
            [attr.aria-label]="
              isConfirmPasswordVisible ? 'show password' : 'hide password'
            "
            class="cursor-pointer"
            matSuffix
            (mousedown)="isConfirmPasswordVisible = !isConfirmPasswordVisible"
          >
            {{ isConfirmPasswordVisible ? "visibility" : "visibility_off" }}
          </mat-icon>
          <mat-error>{{ errorMessageForConfirmPassword }}</mat-error>
        </mat-form-field>
      </form>
    </div>
    <div class="col-md-6">
      <mat-card
        class="password-policy-card border h-100"
        [class.border-danger]="
          (newPasswordFormControl?.touched || newPasswordFormControl?.dirty) &&
          newPasswordFormControl?.invalid
        "
      >
        <mat-card-header>
          <mat-card-title class="dg-txt-primary dg-h-15">
            Password Policy
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <dg-password-policy-wrapper
            [inputRef]="newPasswordRef"
            [existingValidators]="existingValidators"
            [control]="newPasswordFormControl"
          >
          </dg-password-policy-wrapper>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="mat-card-action float-end dg-btn">
  <button
    *ngIf="!dialogData?.hideCancelButton"
    mat-flat-button
    mat-dialog-close
    id="cancel"
    mat-dialog-close
  >
    {{ "cancel" | titlecase }}
  </button>

  <button
    mat-flat-button
    id="reset"
    (click)="onResetClick()"
    type="button"
    class="dg-btn"
  >
    <!--  <mat-icon>clear_all</mat-icon> -->
    {{ "reset" | titlecase }}
  </button>

  <button
    color="primary"
    mat-flat-button
    id="submit"
    (click)="onSaveClick()"
    type="button"
    [disabled]="changePasswordFormGroup?.invalid"
  >
    <!--  <mat-icon>save</mat-icon> -->
    {{ "save" | titlecase }}
  </button>
</mat-dialog-actions>
